import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userService, talentService } from '../../../api/apiService';
import { useAuth } from '../../../contexts/AuthContext';

function HomePage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [talents, setTalents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTalents = async () => {
      try {
        setLoading(true);
        
        // Get user profile
        const userResponse = await userService.getProfile();
        const userData = userResponse?.data?.user;
        
        if (!userData || !userData.talents || !Array.isArray(userData.talents)) {
          console.log("No talents found in user profile");
          setTalents([]);
          setLoading(false);
          return;
        }

        // Extract talent IDs
        const talentIds = userData.talents.map(talent => talent.db_id);
        
        // Fetch talent details
        const talentNames = [];
        for (const talentId of talentIds) {
          try {
            const talentResponse = await talentService.getTalentById(talentId);
            if (talentResponse?.data?.name) {
              talentNames.push(talentResponse.data.name);
            }
          } catch (err) {
            console.error(`Error fetching talent details for ID ${talentId}:`, err);
          }
        }
        
        setTalents(talentNames);
      } catch (error) {
        console.error("Error fetching talents:", error);
        setError("Failed to load talent information");
      } finally {
        setLoading(false);
      }
    };

    fetchTalents();
  }, [currentUser]);

  return (
    <div className="content-wrapper page">
      <div className="content-wrapper">
        <div className='h1-container'>
          <h1>Welcome to TOBS</h1>
          {talents.length > 0 && (
            <div className="talents-list">
              <p>You currently can view and accept orders for:</p>
              <ul>
                {talents.map((talent, index) => (
                  <li key={index}>{talent}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginTop: '40px'
        }}>
          {/* My Bookings Card */}
          <div 
            className="home-card" 
            onClick={() => navigate('./orders')}
          >
            <h2>My Bookings</h2>
            <p>View and manage your bookings</p>
          </div>

          {/* My Calendar Card */}
          <div 
            className="home-card" 
            onClick={() => navigate('./my-calendar')}
          >
            <h2>My Calendar</h2>
            <p>View your calendar and schedule</p>
          </div>

          {/* Manage Availability Card */}
          <div 
            className="home-card" 
            onClick={() => navigate('./vacation')}
          >
            <h2>Manage Your Availability</h2>
            <p>Add and update your availability</p>
          </div>

          {/* My Requests Card */}
          <div 
            className="home-card" 
            onClick={() => navigate('./invitations')}
          >
            <h2>My Requests</h2>
            <p>Manage requested jobs by accepting or denying them</p>
          </div>
        </div>

        <style>{`
      .home-card {
              background: #fff;
              padding-left: 30px;
              padding-right: 30px;
              padding-bottom: 30px;
              padding-top: 30px;
              border-radius: 8px;
              cursor: pointer;
              transition: transform 0.2s;
              border: 1px solid #eee;
          }'
          .talents-list {
            margin: 20px 0;
          }

          .talents-list p {
            font-size: 18px;
            margin-bottom: 10px;
            margin-top: 10px;
          }

          .talents-list ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .talents-list li {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            line-height: 1.5;
          }

          .home-card:hover {
            transform: translateY(-5px);
          }
          
          .home-card h2 {
            margin-bottom: 10px;
            color: #333;
          }
          
          .home-card p {
            color: #666;
            margin: 0;
          }
        `}</style>
      </div>
    </div>
  );
}

export default HomePage;
